import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getDataReceiveH = () => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/get`);
};
export const billing_expense_getDataReceiveByID = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/getbyid/${id}`);
};
export const billing_expense_UpdataStatusInv = (inv_id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/updateinvstatus/${inv_id}`);
};
export const billing_expense_clearStatusInv = (inv_id, inv_type) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/clearinvstatus/${inv_id}/${inv_type}`);
};

export const billing_expense_getDataReceiveHQ = (com_id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/getquery/${com_id}`);
};

export const billing_expense_getDataReceiveHQ_Pagination = (
    page,
    limit,
    sortBy,
    sortOrder,
    com_id
) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/getquery-pagination/${com_id}`, {
        params: { page, limit, sortBy, sortOrder },
    });
};

export const billing_expense_getDataReceiveHQ_Pagination_V2 = (
    page,
    limit,
    sortBy,
    sortOrder,
    com_id,
    company_search,
    department_search,
    search_status,
    datefrom,
    dateto,
    search
) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/getquery-pagination-v2/${com_id}`, {
        params: {
            page,
            limit,
            sortBy,
            sortOrder,
            filters: {
                company_search,
                department_search,
                search_status,
                datefrom,
                dateto,
                search,
            },
        },
    });
};

export const billing_expense_getDataReceiveADHQ = (com_id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/getquery-adjust/${com_id}`);
};

export const billing_expense_getDataReceiveADHQ_Pagination = (
    page,
    limit,
    sortBy,
    sortOrder,
    com_id
) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.TRC_H}` + `/getquery-adjust-pagination/${com_id}`,
        {
            params: { page, limit, sortBy, sortOrder },
        }
    );
};

export const billing_expense_getDataReceiveADHQ_Pagination_V2 = (
    page,
    limit,
    sortBy,
    sortOrder,
    com_id,
    company_search,
    department_search,
    search_status,
    datefrom,
    dateto,
    search
) => {
    // console.log(
    //   `getDataReceiveADHQ_Pagination_V2: page=${page}, limit=${limit}, sortBy=${sortBy}, sortOrder=${sortOrder}, com_id=${com_id}, company_search=${company_search}, department_search=${department_search}, search_status=${search_status}, datefrom=${datefrom}, dateto=${dateto}, search=${search}`
    // );

    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.TRC_H}` + `/getquery-adjust-pagination-v2/${com_id}`,
        {
            params: {
                page,
                limit,
                sortBy,
                sortOrder,
                filters: {
                    company_search,
                    department_search,
                    search_status,
                    datefrom,
                    dateto,
                    search,
                },
            },
        }
    );
};

export const billing_expense_CreateDataReceiveH = (oper, data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/${oper}`, data);
};

export const billing_expense_updateReceiveH = (id, oper, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/${id}/${oper}`, data);
};

export const billing_expense_updateAdjustReceiveH = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/update-adjsut-receicpt/${id}`, data);
};

export const billing_expense_deleteReceiveH = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.TRC_H}` + `/${id}`);
};
